// extracted by mini-css-extract-plugin
module.exports = {"container":"detail_container__2XsoC","content":"detail_content__28Ztu","header":"detail_header__1is8i"};